export default __webpack_public_path__ + "static/media/logo-col-light.dc9a2ec6.svg";